import http from './http'

export default {
  projectAcceptance: {
    get (id) {
      return http.get('/property/projectacceptance/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/property/projectacceptance/getlist', {
        shopId: search.shopId,
        keyword: search.keyword,
        startDate: search.date[0],
        endDate: search.date[1],
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/property/projectacceptance/create', model)
    },
    update (model) {
      return http.post('/property/projectacceptance/update', model)
    },
    delete (id) {
      return http.post('/property/projectacceptance/delete', id)
    }
  },
  repairApplication: {
    get (id) {
      return http.get('/property/repairapplication/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/property/repairapplication/getlist', {
        shopId: search.shopId,
        keyword: search.keyword,
        startDate: search.date[0],
        endDate: search.date[1],
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/property/repairapplication/create', model)
    },
    update (model) {
      return http.post('/property/repairapplication/update', model)
    },
    delete (id) {
      return http.post('/property/repairapplication/delete', id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/property.js